module.exports = __webpack_public_path__ + "static/img/5.e3371c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.png
// module id = PgLh
// module chunks = 0